import React, { useEffect, useState } from 'react';
import CookieConsent from "react-cookie-consent";
import { css } from 'theme-ui'
import { normalizeBlockContentNodes } from '@blocks-helpers';
import { useStaticQuery, graphql, withPrefix } from 'gatsby'

const styles = {
  cookiesBanner: {
    background: `#ffffff`,
    color: `#171515`,
    borderTop: `1px solid #8663db`,
    display: `flex`,
    justifyContent: `center`,
    left: 0,
    alignItems: `center`,
    fontSize: `14px`
  },
  container: {
    flex: `none`,
    width: `60%`
  },
  cookiesButton: {
    background: `rgb(134 99 219)`,
    color: `white`,
    borderRadius: `99px`,
    outline: `none`,
    fontSize: `14px`
  },
  link: {
    fontWeight: 600,
    ':hover': {
      color: `rgb(134, 99, 219)`
    }
  }
}

const query = graphql`
    query CookieContent {
        it: allBlockContent(filter: { page: { in:["site-it/index"] }, identifier: { in: ["cookie"] } }) {
            nodes {
                ...BlockContent
            }
        }
        es: allBlockContent(filter: { page: { in: ["site-es/index"] }, identifier: { in: ["cookie"] } }) {
            nodes {
                ...BlockContent
            }
        }
        uk: allBlockContent(filter: { page: { in: ["site-uk/index"] }, identifier: { in: ["cookie"] }  }) {
            nodes {
                ...BlockContent
            }
        }
        us: allBlockContent(filter: { page: { in: ["site-us/index"] }, identifier: { in: ["cookie"] } }) {
            nodes {
                ...BlockContent
            }
        }
    }
`

const CookiePopup = () => {
  const locale = process.env.GATSBY_BUILD_LANGUAGE
  const [showCookie, setShowCookie] = useState(false);
  useEffect(()=> {
    const timeout = setTimeout(()=> {
      setShowCookie(true);
    }, 5000)
    return () => {
      clearTimeout(timeout)
    }
  }, []);

  try {
    const data = useStaticQuery(query)
    const supportedLanguages = ['es', 'it', 'uk', 'us']
    const allBlockContent = data[supportedLanguages.includes(locale) ? locale : 'uk']
    const content = normalizeBlockContentNodes(allBlockContent?.nodes);
    const cookie = content?.cookie
    if(!cookie) return null
    return (
      showCookie && 
      <CookieConsent
        location="bottom"
        buttonText={cookie.text_2.text}
        cookieName="gatsby-gdpr-google-analytics"
        style={styles.cookiesBanner}
        buttonStyle={styles.cookiesButton}
        contentStyle={styles.container}
      >
      {cookie.description.text}
        <span><a css={css(styles.link)} href={withPrefix('/privacy-policy')}>{cookie.text_1.text}</a></span>
      </CookieConsent>
    )
  } catch(err) {
    console.error(err)
    return <div />
  }
}


export default CookiePopup
